import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

const ModalImagenExpandida = ({ imagen, onClose }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return (
    <AnimatePresence>
      {imagen && (
        <Overlay
          as={motion.div}
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <ModalContenido onClick={(e) => e.stopPropagation()}>
            <BotonCerrar onClick={onClose}>✕</BotonCerrar>
            <ImagenExpandida
              as={motion.img}
              src={imagen}
              alt="Imagen expandida"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.4 }}
            />
          </ModalContenido>
        </Overlay>
      )}
    </AnimatePresence>
  );
};

export default ModalImagenExpandida;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 20px;
`;

const ModalContenido = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ImagenExpandida = styled(motion.img)`
  max-width: 100%;
  max-height: 100%;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 0 0 30px rgba(0,0,0,0.5);
  @media (min-width: 630px) {
    max-height: 70vh;
  }
`;

const BotonCerrar = styled.button`
  position: absolute;
  top: -10px;
  right: -10px;
  background: #fff;
  color: #000;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  box-shadow: 0px 2px 8px rgba(0,0,0,0.3);
  cursor: pointer;
  z-index: 1000;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 600px) {
    width: 35px;
    height: 35px;
    font-size: 1.2rem;
  }
`;